import React, { useEffect, useState } from "react";
import { EmpleadoTable } from "./EmpleadoTable";
import { EmpleadoScreen } from "./EmpleadoScreen";
import { useDispatch, useSelector } from "react-redux";
import { PageHeaderUi } from "../../ui";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { empleadoClearActive, empleadosStartLoad } from "../../../actions";

const EmpleadoListScreen = ({ handleOpenForm }) => {
  const dispatch = useDispatch();
  const { empleados, loading } = useSelector((state) => state.empleado);
  const handleLoad = () => dispatch(empleadosStartLoad());
  return (
    <PageHeaderUi
      title="Empleados"
      subTitle="Listado"
      extra={[
        <ButtonUi
          key="actualizar"
          typeUi={TipoButtonConstants.Actualizar}
          onClick={handleLoad}
        />,
        <ButtonUi
          key="Nuevo"
          typeUi={TipoButtonConstants.Nuevo}
          onClick={handleOpenForm}
        />,
      ]}
    >
      <EmpleadoTable
        data={empleados}
        loading={loading}
        handleOpenForm={handleOpenForm}
      />
    </PageHeaderUi>
  );
};
export const EmpleadoList = () => {
  const dispatch = useDispatch();
  const [visibleForm, setVisibleForm] = useState(false);
  const handleOpenForm = () => setVisibleForm(true);
  const handleCloseForm = () => {
    setVisibleForm(false);
    dispatch(empleadoClearActive());
  };
  useEffect(() => {
    dispatch(empleadosStartLoad());
  }, []);

  if (visibleForm) {
    return <EmpleadoScreen handleCloseForm={handleCloseForm} />;
  } else {
    return <EmpleadoListScreen handleOpenForm={handleOpenForm} />;
  }
};

export default EmpleadoList;
